/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskSummaryDto } from './RiskSummaryDto';
import {
    RiskSummaryDtoFromJSON,
    RiskSummaryDtoFromJSONTyped,
    RiskSummaryDtoToJSON,
    RiskSummaryDtoToJSONTyped,
} from './RiskSummaryDto';

/**
 * 
 * @export
 * @interface GetRiskListResponseDto
 */
export interface GetRiskListResponseDto {
    /**
     * 
     * @type {number}
     * @memberof GetRiskListResponseDto
     */
    totalCount: number;
    /**
     * 
     * @type {Array<RiskSummaryDto>}
     * @memberof GetRiskListResponseDto
     */
    items: Array<RiskSummaryDto>;
}

/**
 * Check if a given object implements the GetRiskListResponseDto interface.
 */
export function instanceOfGetRiskListResponseDto(value: object): value is GetRiskListResponseDto {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetRiskListResponseDtoFromJSON(json: any): GetRiskListResponseDto {
    return GetRiskListResponseDtoFromJSONTyped(json, false);
}

export function GetRiskListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRiskListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(RiskSummaryDtoFromJSON)),
    };
}

export function GetRiskListResponseDtoToJSON(json: any): GetRiskListResponseDto {
    return GetRiskListResponseDtoToJSONTyped(json, false);
}

export function GetRiskListResponseDtoToJSONTyped(value?: GetRiskListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(RiskSummaryDtoToJSON)),
    };
}

